<template>
  <NuxtLink class="block relative rounded overflow-hidden bg-black" :to="{ name: 'campaigns-stockholm-fashion-week' }">
    <div class="relative z-20 text-white px-3 py-2">
      <div class="font-bold uppercase text-sm">
        {{ $t('campaigns.sthlmfw.promo.dates') }}
      </div>
      <div class="font-heading font-medium text-xl leading-5 mb-1.5">
        Exklusiva
        <br>
        erbjudanden
      </div>
      <img class="block h-3 object-contain mb-1" src="/images/stockholm-fashion-week/sthlmfw-logo.png" />
    </div>
    <img class="opacity-60 absolute z-10 top-0 left-0 h-full w-full object-cover object-bottom" src="/images/stockholm-fashion-week/sthlmfw-2025.jpg" />
  </NuxtLink>
</template>

<script setup>
const fat = useFatStore()
</script>

<style lang="scss" scoped>
// bg-gradient-to-r from-ocean to-ocean/60
</style>